import { GridColDef } from "@mui/x-data-grid";
import { formatDateToGermanDate } from "../../utils/helper";

/**
 * Column configuration for the notifications data grid.
 * Defines the structure and formatting of notification data displayed in the grid.
 * 
 * @type {GridColDef[]}
 * 
 * @property {string} field - The field name in the data object
 * @property {string} headerName - The display name for the column header
 * @property {number} flex - The flex grow value for column width
 * @property {Function} [valueGetter] - Optional function to transform the cell value
 * 
 * @example
 * ```tsx
 * <DataGrid
 *   columns={columns}
 *   rows={notifications}
 * />
 * ```
 */
export const columns: GridColDef[] = [
  {
    field: "title",
    headerName: "Titel",
    flex: 1.5,
  },
  {
    field: "type",
    headerName: "Typ",
    flex: 0.5,
  },
  {
    field: "sent_at",
    headerName: "Gesendet am",
    flex: 1,
    valueGetter: ({ row, value }) => {
      return value ? formatDateToGermanDate(new Date(value)) : '-';
    },
  },
];
